import React from 'react';
import { useNavigate } from 'react-router-dom';
import { RbacPermissions } from '../../../../core/interfaces/user';
import { HdRbacButton } from '../../../../components';
import HdShortcut from '../../../../a11y/shortcuts/components/shortcut/HdShortcut';
import useAnalyticsTracker from '../../../../analytics/hooks/useAnalyticsTracker';
import useKeyboardShortcutListener from '../../../../a11y/shortcuts/hooks/useKeyboardShortcutListener';
import { TRACKER_CREATE_TARGET_CLICK } from '../../../activate-target/constants';

export function CreateTargetButton() {
  const { eventTrack } = useAnalyticsTracker();
  const navigate = useNavigate();

  const onCreateTargetClick = () => {
    eventTrack({
      action: TRACKER_CREATE_TARGET_CLICK
    });

    navigate('/target/create');
  };

  useKeyboardShortcutListener(
    () => {
      onCreateTargetClick();
    },
    'activation.create',
    { priority: 0, terminal: 'match', inputs: true }
  );

  return (
    <HdRbacButton
      icon='plus'
      rbacPermission={RbacPermissions.ACTIVATION_CREATE}
      className='ml-5'
      type='button'
      onClick={onCreateTargetClick}
      dataId='create-target'
      tooltipContent={<HdShortcut command='activation.create' />}
    >
      Create Activation Target
    </HdRbacButton>
  );
}
